import React from 'react';

const SummaryItem = ({ label, value, suffix = '', style = {} }) => (
    <div className="summary-gadget__info summary-gadget__card-content_custom" style={{ marginBottom: 6, ...style }}>
        <strong style={{ paddingRight: 5 }}>{label} : </strong>
        <span>{value || 0}{suffix}</span>
    </div>
);

export default SummaryItem;
